/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { WizardTitleEnum } from '../../../enums';

@Injectable()
export class WizardUtilsService {
    /**
     * Loops through a service to find a visible input, loop ends as soon as one visible item is found.
     * @param service
     * @private
     */
    public hasVisibleFields(service: any): boolean {
        let visibleInputs: boolean = false;
        for (const property in service) {
            if (service.hasOwnProperty(property)) {
                const input = service[property];
                if (input.hidden === false) {
                    visibleInputs = true;
                    break;
                }
            }
        }

        return visibleInputs;
    }

    /**
     * Get section index
     * @param sectionName
     * @param wizardSteps
     * @private
     */
    public getSectionIndex(sectionName: string, wizardSteps: any[]): number {
        const index: number = wizardSteps.findIndex(step => step.service.indexOf(sectionName) !== -1);
        if (index === -1 && sectionName === WizardTitleEnum.FRONTENDS) {
            return wizardSteps.findIndex(step => step.service.indexOf(WizardTitleEnum.MONITORS) !== -1);
        }

        return index;
    }

    /**
     * Get last visible step from visible steps
     * @param steps
     * @private
     */
    public getLastVisibleStepIndex(steps: any[]): number {
        const visibleSteps = steps.filter(step => step.isVisible);
        if (visibleSteps.length) {
            const lastVisibleStep = visibleSteps[visibleSteps.length - 1];

            return steps.findIndex(step => step.id === lastVisibleStep.id);
        }
    }

    /**
     * Scroll the active parent step into view.
     * @private
     */
    public scrollActiveInView(): void {
        const activeParentStep = document.querySelectorAll('.step-header-wrapper.active');
        if (activeParentStep?.length) {
            // Note smooth behavior and centre block optional parameters not fully supported in all browsers.
            activeParentStep[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    /**
     * Get the start position for the wizard when a template is loaded successfully.
     * @param steps
     */
    public getStartPosition(steps: any[]): 'first' | 'last' | number | any[] {
        const lastStepIndex = this.getLastVisibleStepIndex(steps);
        if (steps[lastStepIndex].subSteps) {
            const lastSubStep = steps[lastStepIndex]?.subSteps ? 'last' : null;

            return ['last', lastSubStep];
        } else {
            return 'last';
        }
    }
}
